// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".small-hero__rounded-banner[data-v-ab64bd66]{height:100%;position:absolute;width:calc(50% + 16px)}.small-hero__subtitle[data-v-ab64bd66]{font-weight:lighter}.small-hero__banner-placeholder[data-v-ab64bd66]{background-position:50%;background-size:cover;height:64px;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
